"use client"

import { ButtonHTMLAttributes } from "react";
import IconSprite from "../common/IconSprite";
import Modal from "../common/Modal"
import QuationForm from "../quationForm/QuationForm"
import { useModal } from "@/hooks/useModal"
import { cn } from "@/lib/utils"

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  modalTitle: string;
  type?: "button" | "submit" | "reset";
  variant?: "default" | "promotion";
}

export default function QuotationButton({
  modalTitle,
  variant = "default",
  ...props
}: Props) {
  const { isOpen, open, close } = useModal()

  return (
    <>
      <button
        className={cn(
          "relative flex items-center justify-between font-semibold py-4 px-4 text-lg w-full",
          variant === "default" && "bg-matco hover:bg-yellow03 text-dark02",
          variant === "promotion" && "bg-red-dark hover:bg-red-darker text-white"
        )}
        {...props}
        onClick={open}
      >
        COTIZAR RÁPIDO
        <div className="absolute right-0 top-0 bottom-0 flex items-center px-4 bg-black/10">
          <IconSprite id="ic_arrow_right_light" className="h-5 w-5" />
        </div>
      </button>

      <Modal
        isOpen={isOpen}
        onClose={close}
        title={modalTitle}
      >
        <QuationForm onClose={close} />
      </Modal>
    </>
  );
}
